import React from "react";
import { observer } from "mobx-react";

import { analyticsTracker } from "@utils/analytics";
import { BetBuilderPick } from "@data-types/bet-booster/BetBuilderPicks";
import { BetBuilderPickActionsTypeEnum } from "@data-types/analytics-tracker/QuickPlayInteractionTypeEnum";
import BetBuilderPicksEventCard from "@features/quick-play/mobile/bet-builder-picks/components/BetBuilderPicksEventCard";
import { useOfferContext } from "@state/hooks/offer/useOfferContext";
import { OfferStore } from "@state/context/offer/OfferContext";

export const BetBuilderPicksEventSliderItem = observer(
	function BetBuilderPicksEventSliderItem(props: {
		BBPick: BetBuilderPick;
		index: number;
	}) {
		const store = useOfferContext<OfferStore.EventViewStore>();

		const handleClick = (e: React.MouseEvent) => {
			e.stopPropagation();
			e.preventDefault();

			analyticsTracker.trackQuickPlayInteraction(
				BetBuilderPickActionsTypeEnum.PickClick
			);

			store?.betBoosterEventPicks?.betBuilderPicksStore?.activatePopup(
				props.BBPick.id,
				props.index,
				false
			);
		};

		return (
			<div className="carousel__item carousel--most__item">
				<div
					onClick={handleClick}
					className="carousel__slide carousel--most__slide"
				>
					<div className="card card--qp card--qp--nowrap card--bbp card--bbp--nowrap">
						<div className="card__body card--qp__body card--bbp__body">
							<BetBuilderPicksEventCard
								BBPick={props.BBPick}
								maxOffers={2}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
);
